import { Employee } from "@skbkontur/staff-common";

import { CandyThunkAction } from "../../../Engine/Core/Store/CandyReduxTypes";

import { ImportEmployeesActionType } from "./ImportEmployeesAction";

export function cancelImportEmployees(): CandyThunkAction {
    return (dispatch, getState) => {
        getState().importEmployees?.resultDeferred?.resolve(undefined);
        dispatch({ type: ImportEmployeesActionType.EndImport });
    };
}

export function importEmployees(employees: Employee[]): CandyThunkAction {
    return (dispatch, getState) => {
        getState().importEmployees?.resultDeferred?.resolve(employees);
        dispatch({ type: ImportEmployeesActionType.EndImport });
    };
}
